import { types } from '../reducers/appReducer';

// eslint-disable-next-line import/prefer-default-export
export const GetApps = (values) => ({
  type: types.GET,
  payload: values,
});

export const GetWhiteLabelName = (values) => ({
  type: "WHITE_LABEL_NAME",
  payload: values,
});

export const getWhiteLabelProNameFromSpaceId = (values) => ({
  type: 'MAINHUB_NAME_FROM_SPACEID',
  payload: values,
});

export const getSpaceName = (values) => ({
  type: 'SPACE_NAME_FROM_ID',
  payload: values,
});